import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONFIG } from '../../../config';
import { Attachment } from '../../models';
import { AuthorizationService, FileUploadService, RmsUtilsService } from '../../../core/services';
import { PERMISSIONS } from '../../enums/permissions.enum';

@Component({
    selector: 'rms-key-papers',
    templateUrl: './key-papers.component.html',
    styleUrls: ['./key-papers.component.scss'],
    standalone: false
})
export class KeyPapersComponent implements OnInit {

  /**
   * In the template, when passing the `endpoint` `@Input()` value use the next syntax: `/pathStart/{entityId}/pathEnds`
   * Where the literal `{entityId}` will be replaced in the `fileUploadService` with the `entityId` `@Input()` value
   */
  @Input() endpoint: string;
  @Input() entityId: number;
  @Input() keyPapersList: Array<Attachment>;
  @Input() loadingKeyPapersList: boolean;
  @Input() showList: boolean;
  @Output() toggleCollapse: EventEmitter<void> = new EventEmitter<void>();
  private filesToUpload: FileList = null;
  public allowedFileType = CONFIG.fileUploadAllowedExtensions;
  public dateFormat = CONFIG.shortDateFormat;
  public uploadingKeyPapers = false;
  public hasPermission: Record<string, boolean> = {};

  constructor(
    public fileUploadService: FileUploadService,
    private utilsService: RmsUtilsService,
    private authorizationService: AuthorizationService
  ) {
    this.hasPermission = {
      coreAttachmentsCreate: this.authorizationService.hasPermission([PERMISSIONS.CoreAttachmentsCreate])
    };
  }

  ngOnInit() {
  }

  /**
   * Detects input file change and calls the method to upload
   * @param files
   */
  public inputFileChanged(files: FileList): void {
    this.uploadingKeyPapers = true;
    this.filesToUpload = files;
    this.uploadFiles();
  }

  /**
   * Detects changes in the upload file form and triggers the submit
   */
  private uploadFiles(): void {
    this.fileUploadService
      .keyPapersUpload(this.filesToUpload, this.endpoint, this.entityId, 'fileUploadField')
      .finally(() => this.uploadingKeyPapers = false);
  }

  public downloadAttachment(item: Attachment): void {
    this.utilsService.downloadAttachment(item);
  }

  public toggleCollapseClickHandler(): void {
    this.toggleCollapse.emit();
  }

}
